import { render, staticRenderFns } from "./BaseNavbar.vue?vue&type=template&id=520570f1&"
import script from "./BaseNavbar.vue?vue&type=script&lang=js&"
export * from "./BaseNavbar.vue?vue&type=script&lang=js&"
import style0 from "./BaseNavbar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports